<template>
  <div>
    <Cookies />
    <MainMarketApps v-bind:isAuthenticated="isAuthenticated" />
  </div>
</template>
<script>
import MainMarketApps from '../components/main/MainMarketApps';
import Cookies from '../components/cookies/Cookies';
import { mapGetters } from 'vuex';
export default {
  components: {
    Cookies,
    MainMarketApps,
  },
  computed: {
    isAuthenticated: {
      get() {
        return this.$auth.isAuthenticated;
      },
    },
  },
};
</script>
